import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { PublicProgramPage } from "./pages/PublicProgramPage";
import { LiveTranslationListenerPage } from "./pages/LiveTranslationListenerPage";
import { ApplicationsMenuPage } from "./pages/ApplicationsMenuPage";
import "./styles.css";

const publicProgramMatch = window.location.pathname.match(/^\/programa\/(\d+)\/?$/);
const liveTranslationMatch = window.location.pathname.match(/^\/escuchar\/(\d+)\/?$/);
const applicationsPathMatch = window.location.pathname.match(/^\/(?:applications|aplicaciones)\/?$/);
const applicationsHostname = window.location.hostname.toLowerCase();
const isLocalApplicationsHost = applicationsHostname === "localhost" || applicationsHostname === "127.0.0.1";
if (applicationsPathMatch && applicationsHostname !== "app.virtualmedica.com" && !isLocalApplicationsHost) {
  window.location.replace("https://app.virtualmedica.com");
}
const applicationsMenuMatch = applicationsPathMatch
  || (applicationsHostname === "app.virtualmedica.com" && window.location.pathname === "/");
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {applicationsMenuMatch ? <ApplicationsMenuPage /> : publicProgramMatch ? <PublicProgramPage eventId={Number(publicProgramMatch[1])} /> : liveTranslationMatch ? <LiveTranslationListenerPage sessionId={Number(liveTranslationMatch[1])} /> : <App />}
  </StrictMode>,
);
